import React from "react";
import PropTypes from "prop-types";

import formatPublishedDate from "utils/formatPublishedDate";
import { MicrodataContext } from "config/contexts";

import styles from "./PubDate.css";

export default function PubDate({ story }) {
  return (
    <MicrodataContext.Consumer>
      {microdata => (
        <time
          itemProp={microdata ? "datePublished" : undefined}
          title={formatPublishedDate(story, true)}
          dateTime={story.published_date}
          className={styles.root}
        >
          {formatPublishedDate(story)}
        </time>
      )}
    </MicrodataContext.Consumer>
  );
}

PubDate.propTypes = {
  story: PropTypes.shape({
    published_date: PropTypes.string,
    status: PropTypes.string,
  }).isRequired,
};
